(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    (function () {
    var COLLECTION_KEY = 'breadcrumbs:last_collection';
    var PAGE_KEY = 'breadcrumbs:last_page';
    var referrer = document.referrer;
    var referrerPath = '';

    try {
      if (referrer) referrerPath = new URL(referrer).pathname;
    } catch (e) {}

    // On page pages, save the current page
    var pageEl = document.querySelector('[data-breadcrumb-page]');
    if (pageEl) {
      sessionStorage.setItem(
        PAGE_KEY,
        JSON.stringify({
          title: pageEl.dataset.breadcrumbPage,
          url: pageEl.dataset.breadcrumbUrl,
        })
      );
      sessionStorage.removeItem(COLLECTION_KEY);
    }

    // On collection pages, save the current collection
    var collEl = document.querySelector('[data-breadcrumb-collection]');
    if (collEl) {
      sessionStorage.setItem(
        COLLECTION_KEY,
        JSON.stringify({
          title: collEl.dataset.breadcrumbCollection,
          url: collEl.dataset.breadcrumbUrl,
        })
      );

      // Only inject page parent if user actually came from a /pages/ URL
      var cameFromPage = referrerPath.startsWith('/pages/');
      if (!cameFromPage) {
        sessionStorage.removeItem(PAGE_KEY);
      }

      var pagePlaceholder = document.querySelector('[data-breadcrumb-page-placeholder]');
      if (pagePlaceholder && cameFromPage) {
        var savedPage = sessionStorage.getItem(PAGE_KEY);
        if (savedPage) {
          var page = JSON.parse(savedPage);
          pagePlaceholder.innerHTML =
            '<span class="breadcrumbs__separator" aria-hidden="true">' +
            pagePlaceholder.dataset.separator +
            '</span>' +
            '<a class="breadcrumbs__link" href="' +
            page.url +
            '">' +
            page.title +
            '</a>';
          pagePlaceholder.removeAttribute('hidden');
        }
      }
    }

    // On product pages with no server-side collection context
    var productPlaceholder = document.querySelector('[data-breadcrumb-collection-placeholder]');
    if (productPlaceholder) {
      var cameFromCollection = referrerPath.startsWith('/collections/');

      // If user didn't come from a collection, clear stale context
      if (!cameFromCollection) {
        sessionStorage.removeItem(COLLECTION_KEY);
        sessionStorage.removeItem(PAGE_KEY);
      }

      var savedCollection = sessionStorage.getItem(COLLECTION_KEY);
      var savedPageCtx = sessionStorage.getItem(PAGE_KEY);
      var html = '';
      var sep = productPlaceholder.dataset.separator;

      if (savedPageCtx) {
        var pg = JSON.parse(savedPageCtx);
        html +=
          '<span class="breadcrumbs__separator" aria-hidden="true">' +
          sep +
          '</span>' +
          '<a class="breadcrumbs__link" href="' +
          pg.url +
          '">' +
          pg.title +
          '</a>';
      }

      if (savedCollection) {
        var coll = JSON.parse(savedCollection);
        html +=
          '<span class="breadcrumbs__separator" aria-hidden="true">' +
          sep +
          '</span>' +
          '<a class="breadcrumbs__link" href="' +
          coll.url +
          '">' +
          coll.title +
          '</a>';
      }

      if (html) {
        productPlaceholder.innerHTML = html;
        productPlaceholder.removeAttribute('hidden');
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
